import React, { useState } from 'react';
import './index.scss';
import { history } from 'umi';
import { Layout, Tab } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
// mobile compare的所有样式 都是这里引入的
import '@/pages/intelligence/assets/scss/Compare/mobileGames.scss';
import SameStartDate from './SameStartDate';
import DifferentStartDate from './DifferentStartDate';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Body, Content } = Layout;

// PcConsoleGames-Beta版本
const PcConsoleGamesBeta = (props: any) => {
  const [activeId, setActiveId] = useState(
    props?.match?.params?.tab || 'same_start_date',
  );
  const { formatMessage } = useIntlExtend();

  const tabs = [
    {
      id: 'same_start_date',
      label: formatMessage({ id: 'dbi_compare_pcconsole_same_start_date' }),
      component: <SameStartDate />,
    },
    {
      id: 'different_start_date',
      label: formatMessage({
        id: 'dbi_compare_pcconsole_different_start_date',
      }),
      disabled: true,
      component: <DifferentStartDate />,
    },
  ];

  const handleActiveIdChange = (tab: Tab) => {
    setActiveId(tab.id);
    history.replace(`/intelligence/compare/PcConsoleGamesBeta/${tab.id}`);
  };

  return (
    <Layout className="dbi-compare-mobile">
      <Body>
        <Content>
          <Content.Header
            // className="contentHead-normal"
            title={
              <div className="dbi-compare-mobile_title">
                <span>
                  {formatMessage({
                    id: 'dbi_compare_pcconsole_games_beta_title',
                  })}
                </span>
              </div>
            }
          >
            {/* <div className="header-tab dbi-header-tab">
              <Tabs
                className="dbi-page-tabs"
                newMarkIdsMappingKey="CompareMobileGames"
                ceiling={true}
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={handleActiveIdChange}
              />
            </div> */}
          </Content.Header>

          <Content.Body full>
            <MarqueeBanner />
            {tabs.map((e) => (
              <div key={e.id}>{e.id === activeId ? e.component : ''}</div>
            ))}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default PcConsoleGamesBeta;
